





































import Vue from 'vue';
import _ from 'lodash';
import { sanityClient } from '@/config/sanity';
import Employee from '@/models/employee';
import SanityEmployee from '@/models/sanitySchema/sanityEmployee';
import LargeButton from '@/models/largeButton';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import TextWithHeadlinePanel from '@/components/TextWithHeadlinePanel.vue';
import TextWithPeoplePanel from '@/components/TextWithPeoplePanel.vue';
import EmployeesPanel from '@/components/EmployeesPanel.vue';
import SpeakerWithGradient from '@/components/SpeakerWithGradient.vue';
import LargeButtonsPanel from './LargeButtonsPanel.vue';

interface AboutUsPage {
  aboutUsPanel: {
    headline: string;
    text: string;
    image: string;
  };
  buttons: Array<LargeButton>;
  howWeWorkPanel: {
    headline: string;
    text: string;
    contactPersons: Array<Employee>;
  };
  employeesPanel: {
    headline: string;
  };
}

interface Data {
  isLoading: boolean;
  error: string;
  page: AboutUsPage | null;
  employees: Array<Employee>;
}

export default Vue.extend({
  name: 'AboutUs',
  components: {
    LoadingIndicator,
    ErrorMessage,
    TextWithHeadlinePanel,
    TextWithPeoplePanel,
    EmployeesPanel,
    LargeButtonsPanel,
    SpeakerWithGradient,
  },
  data(): Data {
    return {
      isLoading: true,
      error: '',
      page: null,
      employees: [],
    };
  },
  created() {
    this.fetchPage();
  },
  methods: {
    fetchEmployees() {
      const query = `*[_type == "employee"]{
        _createdAt,
        _updatedAt,
        name,
        slug,
        title,
        department,
        image,
        order,
        person->{name,slug,image,title,department,order},
      }`;

      return sanityClient.fetch(query).then(
        (results) => {
          const normalizedEmployees = results.map((e: SanityEmployee) => {
            if (e.person) {
              return {
                name: e.person.name,
                title: e.person.title,
                department: e.person.department,
                image: e.person.image,
                order: e.person.order,
              };
            }
            return {
              name: e.name,
              title: e.title,
              department: e.department,
              image: e.image,
              order: e.order,
            };
          });

          const techEmployees = normalizedEmployees.filter((e: Employee) => e.department === 'technology');
          const sortedTechEmployees = _.sortBy(techEmployees, 'order', 'asc');
          const mediaEmployees = normalizedEmployees.filter((e: Employee) => e.department === 'media');
          const sortedMediaEmployees = _.sortBy(mediaEmployees, 'order', 'asc');
          const strayEmployees = normalizedEmployees.filter((e: Employee) => !e.department);

          this.employees = [
            ...sortedTechEmployees,
            ...sortedMediaEmployees,
            ...strayEmployees,
          ];
        },
        (error) => {
          this.error = error;
        },
      );
    },
    fetchAboutUsPageFields() {
      const query = `*[_type == "aboutUsPage"]{
        _createdAt,
        _updatedAt,
        aboutUsPanelHeadline,
        aboutUsText,
        aboutUsImage,
        buttons,
        howWeWorkPanelHeadline,
        howWeWorkText,
        howWeWorkContactPersons[] -> {
          name,
          image,
          title,
          department
        },
        employeesPanelHeadline
      }`;

      return sanityClient.fetch(query).then(
        (results) => {
          const page = results[0];
          this.page = {
            aboutUsPanel: {
              headline: page.aboutUsPanelHeadline,
              text: page.aboutUsText,
              image: page.aboutUsImage,
            },
            buttons: page.buttons,
            howWeWorkPanel: {
              headline: page.howWeWorkPanelHeadline,
              text: page.howWeWorkText,
              contactPersons: page.howWeWorkContactPersons,
            },
            employeesPanel: {
              headline: page.employeesPanelHeadline,
            },
          };
        },
        (error) => {
          this.error = error;
        },
      );
    },
    fetchPage() {
      this.isLoading = true;
      Promise.all([
        this.fetchAboutUsPageFields(),
        this.fetchEmployees(),
      ]).then(() => {
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
      });
    },
  },
});
